import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { CoachEducation } from "../../models/coacheducation"

@Injectable({
  providedIn: "root",
})
export class CoachEducationDisplayDataResolver
  implements DisplayDataResolver<CoachEducation>
{
  typeDisplayName = "CoachEducation"

  constructor() {}

  getIcon(entity: CoachEducation): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: CoachEducation): string | undefined {
    return undefined
  }

  getSubTitle(entity: CoachEducation): string | undefined {
    return undefined
  }

  getTitle(entity: CoachEducation): string {
    return entity.id
  }

  getShortTitle(entity: CoachEducation): string {
    return entity.id
  }

  getItemHref(entityOrID: CoachEducation | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/coachEducation"
    }
    if (typeof entityOrID === "string") return "/app/coachEducation/" + entityOrID
    return "/app/coachEducation/" + entityOrID.id
  }
}
